// clinicalStageInitialValues.js

export const clinicalStageInitialValues = {
    disease_extent: "",
    disease_extent_other: "",

    clinical_t: "",
    clinical_n: "",
    clinical_m: "",

    pathological_t: "",
    pathological_n: "",
    pathological_m: "",
};

// Map GET response to Formik values
export const mapClinicalStageResponse = (data) => {
    if (!data) return clinicalStageInitialValues;

    return {
        disease_extent: data?.disease_extent || "",
        disease_extent_other:
            data?.disease_extent === "Others" ? data?.disease_extent_other || "" : "",

        clinical_t: data?.clinical_t || "",
        clinical_n: data?.clinical_n || "",
        clinical_m: data?.clinical_m || "",

        pathological_t: data?.pathological_t || "",
        pathological_n: data?.pathological_n || "",
        pathological_m: data?.pathological_m || "",
    };
};
